<script lang="ts">
import type { Temporal } from 'temporal-polyfill';
import type { DisplayBlockProps } from '~/types/display-block';
import { supportedDateFieldTypes } from '#layers/blocks/blocks/Input/InputDate.block.vue';

interface DisplayFormattedDateProps extends DisplayBlockProps<Temporal.PlainDate> {
	format?: 'short' | 'medium' | 'long' | 'full';
}

const __DsBlock = {
	type: 'display',
	name: '$t:blocks.display_formatted_date.name',
	description: '$t:blocks.display_formatted_date.description',
	icon: 'lucide:calendar',
	category: 'display',
	hidden: true,

	fieldBinding: {
		supportedTypes: supportedDateFieldTypes,
	},

	options: [
		{
			name: 'value',
		},
		{
			name: 'format',
			type: 'enum',
			values: ['short', 'medium', 'long', 'full'],
		},
	],
}</script>

<script setup lang="ts">
import { computed } from 'vue';
import { isNil } from '#layers/base';
import { defineBlock } from '#layers/block-engine';

const props = withDefaults(defineProps<DisplayFormattedDateProps>(), {
	format: 'medium',
});

;

const formattedDate = computed(() => props.value?.toLocaleString(undefined, {
	dateStyle: props.format,
}));
</script>

<template>
	<DDisplayValueEmpty v-if="isNil(value)" />
	<div v-else>
		{{ formattedDate }}
	</div>
</template>
